export default __webpack_public_path__ + "static/keijiban-banner-e4ca5258d3b3fdbb166857485a6abfc4.svg";